(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lead-capture-landing"] && !Shopify.designMode) return;
  try {
    
  /* ---------------------------------------------------------------
     4T2 lead-capture landing page.
     Concatenated into a site-wide scripts.js and loaded async on EVERY
     page, so it exits immediately when the section is absent.
     No Liquid in here — it is not rendered inside the javascript tag.
     --------------------------------------------------------------- */
  (function () {
    'use strict';

    function boot() {
      var root = document.querySelector('[data-lcl-root]');
      if (!root || root.dataset.lclReady === '1') return;
      root.dataset.lclReady = '1';

      var cfgEl = root.querySelector('[data-lcl-config]');
      var cfg;
      try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

      var step1  = root.querySelector('[data-lcl-step="1"]');
      var step2  = root.querySelector('[data-lcl-step="2"]');
      var done   = root.querySelector('[data-lcl-step="done"]');
      var form   = root.querySelector('[data-lcl-emailform]');
      var input  = root.querySelector('#lcl-email');
      var submit = root.querySelector('[data-lcl-submit]');
      var errEl  = root.querySelector('[data-lcl-error]');
      var back   = root.querySelector('[data-lcl-back]');
      var dots   = root.querySelector('[data-lcl-dots]');
      var dot1   = root.querySelector('[data-lcl-dot="1"]');
      var dot2   = root.querySelector('[data-lcl-dot="2"]');
      if (!step1 || !step2 || !form || !input) return;

      var answer = null, sending = false;

      function log() {
        if (!cfg.debug) return;
        var a = Array.prototype.slice.call(arguments);
        a.unshift('[4T2 lp]'); console.log.apply(console, a);
      }
      function showError(m) {
        errEl.textContent = m || '';
        input.setAttribute('aria-invalid', m ? 'true' : 'false');
      }

      /* ---- step 1 to step 2, no confirm click ---- */
      root.addEventListener('click', function (ev) {
        var btn = ev.target.closest('[data-lcl-answer]');
        if (!btn || !root.contains(btn)) return;
        answer = btn.getAttribute('data-lcl-value') || '';
        btn.classList.add('is-picked');
        step1.classList.add('is-gone');
        step2.classList.add('is-active');
        if (dot1) dot1.classList.remove('is-on');
        if (dot2) dot2.classList.add('is-on');
        try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
        log('answer', answer);
      });

      if (back) back.addEventListener('click', function () {
        step2.classList.remove('is-active');
        step1.classList.remove('is-gone');
        showError('');
        if (dot2) dot2.classList.remove('is-on');
        if (dot1) dot1.classList.add('is-on');
        var p = root.querySelector('[data-lcl-answer].is-picked');
        if (p) { p.classList.remove('is-picked'); try { p.focus(); } catch (e) {} }
        answer = null;
      });

      /* ---- consent. Verified surface: Shopify.loadFeatures then
         customerPrivacy.marketingAllowed(). visitorConsentCollected fires only
         ON CHANGE, never on attach, so read state once and also subscribe. ---- */
      var consentKnown = false, marketingOK = false, pendingLead = null;

      function readConsent() {
        try {
          var cp = window.Shopify && window.Shopify.customerPrivacy;
          if (!cp || typeof cp.marketingAllowed !== 'function') return false;
          marketingOK = !!cp.marketingAllowed();
          consentKnown = true;
          log('marketingAllowed =', marketingOK);
          return true;
        } catch (e) { return false; }
      }

      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          if (err) { log('consent api failed to load; staying silent'); return; }
          readConsent();
          if (pendingLead && marketingOK) { fireLead(pendingLead); pendingLead = null; }
        });
      } else { readConsent(); }

      document.addEventListener('visitorConsentCollected', function (ev) {
        marketingOK = !!(ev.detail && ev.detail.marketingAllowed);
        consentKnown = true;
        log('consent changed ->', marketingOK);
        if (pendingLead && marketingOK) { fireLead(pendingLead); pendingLead = null; }
      });

      /* ---- exactly one Lead per signup, consent-gated ---- */
      var leadFired = false;

      function uuid() {
        try {
          if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
        } catch (e) {}
        return 'lcl-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      }

      function fireLead(p) {
        if (leadFired) { log('already fired'); return; }
        if (!marketingOK) { log('no consent, not firing'); return; }
        if (typeof window.fbq !== 'function') { log('fbq absent'); return; }
        leadFired = true;
        /* trackSingle, not track: this business has four datasets and two are
           still active, and a bare track would fan out to all of them. */
        window.fbq('trackSingle', cfg.pixelId, 'Lead', {
          content_name: cfg.landingPage,
          content_category: cfg.signupSource
        }, { eventID: p.eventId });
        log('Lead fired, eventID', p.eventId);
      }

      /* ---- Klaviyo client subscribe ----
         Endpoint, method, revision header and the 202 success status are
         verified. THE BODY SHAPE BELOW IS THE ONE UNVERIFIED PIECE — Klaviyo's
         reference page would not yield its payload schema. The catch block
         prints Klaviyo's own error text, which names the offending field. If
         the first live test submit returns 4xx, read the console and correct
         ONLY this object. Nothing else depends on its shape. */
      function buildBody(email) {
        var props = { signup_source: cfg.signupSource, landing_page: cfg.landingPage };
        props[cfg.questionProperty] = answer;
        return {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: cfg.signupSource,
              profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
            },
            relationships: { list: { data: { type: 'list', id: cfg.listId } } }
          }
        };
      }

      function looksLikeEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

      function succeed(eventId) {
        step2.classList.remove('is-active');
        step1.classList.add('is-gone');
        done.hidden = false;
        if (dots) dots.classList.add('is-done');
        showError('');
        var h = root.querySelector('[data-lcl-done-head]');
        if (h) { try { h.focus(); } catch (e) {} }

        /* consent gates tracking, never the signup. If consent is unknown or
           declined, park the event; visitorConsentCollected fires it later. */
        if (consentKnown && marketingOK) fireLead({ eventId: eventId });
        else { pendingLead = { eventId: eventId }; log('lead parked pending consent'); }

        /* optional auto-redirect. Off by default, and deliberately so: it
           throws away the confirmation the person just earned and can cut the
           Lead event off mid-flight. */
        if (cfg.autoRedirect && cfg.redirectUrl) {
          /* only navigate to a resolved path or absolute http(s) URL. A url-type
             setting holding a shopify:// reference normally resolves on output,
             but if it ever arrives raw, navigating to it would fail silently. */
          var ok = /^\/(?!\/)/.test(cfg.redirectUrl) || /^https?:\/\//.test(cfg.redirectUrl);
          if (!ok) { log('redirect url not navigable, skipping:', cfg.redirectUrl); }
          else {
            var wait = Math.max(1500, (cfg.redirectDelay || 3) * 1000);
            log('auto-redirecting in', wait, 'ms');
            setTimeout(function () { window.location.href = cfg.redirectUrl; }, wait);
          }
        }
      }

      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (sending) return;
        var email = (input.value || '').trim();
        if (!looksLikeEmail(email)) {
          showError(cfg.errors.email);
          try { input.focus(); } catch (e) {}
          return;
        }
        sending = true; submit.disabled = true; showError('');

        var eventId = uuid();
        window.fourT2LastLeadEventId = eventId;  /* for a later server-side copy */

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.companyId), {
          method: 'POST',
          headers: { 'content-type': 'application/json', 'revision': cfg.revision },
          body: JSON.stringify(buildBody(email))
        })
        .then(function (res) {
          /* 202 is the documented success. Klaviyo treats an already-subscribed
             profile as a successful subscribe, so there is no separate branch:
             the person sees success either way, which is correct. */
          if (res.status >= 200 && res.status < 300) { succeed(eventId); return null; }
          return res.text().then(function (t) {
            log('subscribe failed', res.status, t);
            console.warn('[4T2 lp] Klaviyo ' + res.status + ': ' + t);
            throw new Error('klaviyo ' + res.status);
          });
        })
        .catch(function (e) {
          log('error', e);
          showError(cfg.errors.network);
          sending = false; submit.disabled = false;
        });
      });

      log('ready', { list: cfg.listId, page: cfg.landingPage, prop: cfg.questionProperty });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  })();

  } catch(e) { console.error(e); }
})();
})();
